import React from 'react';

const PortfolioDetails = (props) => {
return ( 
       <div>PortfolioDetails</div>
    ) 
}

export default PortfolioDetails;